var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ul",
    { staticClass: "image-grid" },
    _vm._l(_vm.images, function(image, index) {
      return _c(
        "li",
        { key: index },
        [
          _c("lazy-background-image", { attrs: { src: image.sizes.large } }, [
            _vm.lightbox
              ? _c("a", {
                  attrs: { href: image.url },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.didSelectOpenImageGallery(index)
                    }
                  }
                })
              : _vm._e()
          ])
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// /home/omer/Projects/Arcadian/embl/wp-content/themes/embl/node_modules/vue-loader/lib/loaders/templateLoader.js?{}!/home/omer/Projects/Arcadian/embl/wp-content/themes/embl/node_modules/vue-loader/lib?{}!./scripts/vue/ImageGallery.vue?vue&type=template&id=adf0ceaa&
// module id = 84
// module chunks = 0